import React from 'react';
import styled from 'styled-components';
import { formatAggregatedHour } from 'shared/utils/payroll';

const Wrapper = styled.div``;

const HoursRenderer = ({
  rowData: { summarized, subRows, aggregatedHoursTotalRow, aggregatedHoursTotal, payroll },
  columnData: { key }
}) => {
  if (subRows) {
    return <Wrapper>{formatAggregatedHour(aggregatedHoursTotalRow?.[key])}</Wrapper>;
  }
  if (summarized) {
    return <Wrapper>{formatAggregatedHour(aggregatedHoursTotal?.[key])}</Wrapper>;
  }

  const value = payroll?.aggregatedHours?.[key];

  return <Wrapper>{formatAggregatedHour(value)}</Wrapper>;
};

export default HoursRenderer;
